import { geniFetch } from "./geniBackend";

export type PreferredMarketplace = "wb" | "ozon" | "kaspi" | "flip" | "olx";

export const savePreferredMarketplace = async (marketplace: PreferredMarketplace) => {
  await geniFetch("/account/profile", {
    method: "PATCH",
    body: JSON.stringify({
      metadata: {
        preferredMarketplace: marketplace,
      },
    }),
  });
};
